import React from 'react';
import config from '../../../../../config/environment';
import { FaIndianRupeeSign } from 'react-icons/fa6';
const SERVER_URL = config.SERVER_URL;

const RelatedItems: React.FC<any> = ({
  relatedItems,
  goToProductDetailsPage,
  customerId,
  callForRewardPage = false,
}) => {
  return (
    <>
      <div className='text-center pt-4'>
        {!callForRewardPage && (
          <p className='font-semibold text-2xl sm:text-2xl md:text-3xl lg:text-3xl text-[#4A2D1A] font-rubik'>
            Related Products
          </p>
        )}
      </div>
      <div className='flex items-center justify-center my-2 sm:my-2 md:my-2 lg:my-4 '>
        <div className='mx-[.5%] sm:mx-[.5%] md:mx-[1%] lg:mx-[8%] p-3 sm:p-3 md:p-2 lg:p-4'>
          <div className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-2 md:gap-6 lg:gap-6'>
            {relatedItems.map((product: any, index: number) => (
              <div
                key={index}
                onClick={() => goToProductDetailsPage(product?.item_code)}
                className='cursor-pointer border bg-white rounded-xl drop-shadow-xl hover:drop-shadow-2xl transition-shadow duration-300  p-2 sm:p-2 md:p-4 lg:p-4 flex flex-col justify-between'
              >
                <img
                  src={SERVER_URL + product.website_image}
                  alt={product.item_name}
                  className='min-h-[12rem] max-h-[12rem] min-w-40 max-w-80 
                    sm:min-h-[12rem] sm:max-h-[12rem] sm:min-w-40 sm:max-w-80
                    md:min-h-[14rem] md:max-h-[14rem] md:min-w-48 md:max-w-[24rem]
                    lg:min-h-[16rem] lg:max-h-[16rem] lg:min-w-48 lg:max-w-[26rem]'
                />
                <h3 className='text-xs sm:text-xs md:text-xl  lg:text-xl mt-0 sm:mt-0 md:mt-1 lg:mt-2 mb-2 font-bold sm:font-bold md:font-semibold lg:font-semibold font-poppins'>
                  {product.item_name}
                </h3>
                {product.uom_conversion?.find((u: any) => u.uom === 'Nos')?.conversion_factor && (
                  <p className='text-[10px] sm:text-[10px] md:text-sm lg:text-sm text-[#00000] sm:text-[#00000] md:text-gray-500 lg:text-gray-500 font-poppins'>
                    Pack Of{' '}
                    {product.uom_conversion
                      ? product.uom_conversion?.find((u: any) => u.uom === 'Nos')?.conversion_factor
                      : '--'}
                  </p>
                )}
                <div className='flex items-center justify-between mt-0 sm:mt-0 md:mt-2 lg:mt-2'>
                  {customerId && customerId.current && customerId.current !== '' && (
                    <>
                      <div className='flex items-center font-poppins text-black font-medium text-[10px] sm:text-[10px] md:text-base lg:text-base ml-0 sm:ml-0  md:-ml-1 lg:-ml-1'>
                        <FaIndianRupeeSign />
                        <span className='text-xs sm:text-xs md:text-lg lg:text-lg pr-0 sm:pr-0 md:pr-1 lg:pr-1 font-poppins font-semibold sm:font-semibold md:font-semibold lg:font-medium'>
                          {product.web_price ? Number(product.web_price).toFixed(2) : '00.00'}
                        </span>
                        <div className='flex items-center text-gray-400'>
                          <FaIndianRupeeSign className='text-[9px] sm:text-[9px] md:text-sm lg:text-sm' />
                          <span className='font-poppins line-through text-[9px] sm:text-[9px] md:text-sm lg:text-sm'>
                            {product.formatted_mrp}{' '}
                          </span>
                        </div>
                      </div>
                      <div className='flex items-center'>
                        <button
                          onClick={() => goToProductDetailsPage(product?.item_code)}
                          className='px-2 sm:px-2 md:px-3.5 lg:px-3.5 py-1 border border-[#C12E2A] text-[#C12E2A] rounded-md sm:rounded-md md:rounded-lg lg:rounded-lg hover:bg-red-100 transition text-[9px] sm:text-[9px] md:text-xs lg:text-xs font-medium font-poppins'
                        >
                          Buy Now
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default RelatedItems;
